import { isEmpty, isNil } from "lodash";
import { type Resolver, useForm } from "react-hook-form";

export type OrderImporterFormValues = {
  ordersUrl: string;
  companyUuid: string;
};

const resolver: Resolver<OrderImporterFormValues> = async (formValues) => {
  const errors: {
    [property in keyof OrderImporterFormValues]?: {
      type: string;
      message: string;
    };
  } = {};

  const { ordersUrl } = formValues;

  if (isNil(ordersUrl) || isEmpty(ordersUrl)) {
    errors.ordersUrl = {
      type: "required",
      message: "Orders URL is required",
    };
  }

  return {
    values: formValues,
    errors,
  };
};

const useImportOrdersForm = () => {
  return useForm({ resolver });
};

export default useImportOrdersForm;
